// extracted by mini-css-extract-plugin
export var calendarView = "_ig-0";